import Mustache from 'mustache';

export const useCases = [{
    name: "Build tribe",
    description: "Gain trust and attention by regularly sharing relevant content. The goal is to build a strong and coherent community that's ready to buy from you later.",
    tactics: [{
        name: "Talk about competition",
        description: "Talk about positive examples and inspiration in the industry from the perspective of my organization's potential competitors."
    }, {
        name: "Name industry pains",
        description: "Name in bullet form the most painful problems of the field that bother everyone who has been in the field for a long time and considers himself a member of the field. Begin by listing the pain points of the industry and then conclude by gently and non-violently suggesting that our company is competent to understand the issues and therefore we are the right partner to start discussing solutions."
    },{
        name: "Discuss industry trends",
        description: "Discuss one selected and specific point of interest in the field defined earlier. Randomly select an interesting fact or even a trend in the field that is either very current or has been known for a long time, but is still relevant so that the recipient of this text feels that you have deep insight into the field. Highlight a current or long-known but still relevant trend, its impact on the industry, and positive expectations associated with it. Talk about what this trend means for the industry, what impact it may have and what factors in the industry such as employees, costs, revenues, customers, innovation, the business sector in general or even others. Try to describe rather the possible positive impacts and expectations associated with this trend."
    },{
        name: "Talk about organization",
        description: "Speak in an informative, interesting, attention-grabbing style about a specific organization and its business in a specific industry with specific products it offers. Use as much as possible the data you have on the organisation to frame the organization as a forward-moving, appealing company. The aim is that this message stays in the mind of the recipient of the message. The recipient should get the feeling that the organisation is worth following as a leader in the industry because of its interesting news. "
    },{
        name: "Talk about products",
        description: "Select and highlight one product from our portfolio, as described in the \"{{ productDescription }}\". Use an informative yet interesting tone, incorporating gentle humor that is appropriate and acceptable for business professionals. The goal is to inform, entertain, and foster a sense of community among B2B customers."
    },{
        name: "Seasonal news",
        description: "Choose a significant historical event occurring during this calendar week. Relate this historical event to our organization's role in our industry and our products described in organization metadata. The newsletter should connect the past with our current innovations, fostering a sense of community and loyalty among customers."
    }]
}, {
    name: "Digital sales",
    description: "Offer of services or products with the goal of selling them using various forms of argumentation. This moves beyond the awareness phase in the simplified sales cycle of awareness, consideration, and decision.",
    tactics: [{
        name: "Sell with stories",
        description: "Write a story using data about your organization, industry, and product portfolio that leverages emotional and psychological aspects of human behavior, creates empathy between customer needs and the benefits of our products or services, allows our brand to connect with our audience on a deeper level than traditional advertising methods, and helps make the brand or product more memorable. The story should have an engaging beginning and a punchline at the end that demonstrates how the topic mentioned in the beginning can be solved by our company and its services."
    }, {
        name: "Ask qualification questions",
        description: "Ask the right qualifying questions that make the recipient realize they have an unresolved business problem or shortcoming. Addressing this gap, our supplier, operating in the industry and offering its products and solutions, could significantly help them solve that problem. Generate three relevant qualification questions where the solution targets our ideal client for resale services."
    }, {
        name: "Free pilot",
        description: "Offer the customer the opportunity to try a specific product \"{{ productName }}\": \"{{ productDescription }}\" from our portfolio as a one, two, or three-month free pilot. Emphasize the \"free pilot\" in the text as a strong appeal and argument to buy. Consider the nature of the product, such as offering free initial months for a regular monthly paid service or a free loan of the product for a month for a planned purchase. Conclude the offer by stating that this special offer is valid for a limited time."
    }, {
        name: "Propose value of product XY",
        description: "Select a product \"{{ productName }}\" described as \"{{ productDescription }}\" and craft a compelling value proposition for it. Highlight the product's features and explain how it addresses customers' business problems. Create a bullet list that outlines the benefits the product delivers, emphasizing its attractiveness and differentiation from competitors. Ensure the tone is engaging and persuasive to captivate the audience and drive interest."
    }, {
        name: "Offer time limited discount",
        description: "Offer the customer a discount on the purchase of a specific product \"{{ productName }}\" worth about 10%. Ensure the discount doesn't significantly reduce margins and remains attractive to the customer. Use multiples of 5% (5%, 10%, 15%, 20%, or a maximum of 25%). Highlight the value the customer will receive for the product and stress that this discount offer is only valid for a limited period.",
    }, {
        name: "Free consulting",
        description: "Offer free consulting services for a complex product \"{{ productName }}\": \"{{ productDescription }}\" that requires expert advice for its deployment or use. Highlight that our consultants are top experts in the field. Frame the text to showcase the benefits, value, and problem-solving capabilities of the consultancy services associated with the offered product. Conclude by stating that this offer has a limited time validity.",
    }]
}, {
    name: "Churn Prevention",
    description: "",
    disabled: true,
    tactics: [],
}, {
    name: "Product Bundles",
    description: "",
    disabled: true,
    tactics: [],
}, {
    name: "Event Invitation",
    description: "",
    disabled: true,
    tactics: [],
}, {
    name: "Customer-Product Match",
    description: "",
    disabled: true,
    tactics: [],
}, {
    name: "Exploratory Analytics",
    description: "",
    disabled: true,
    tactics: [],
}, {
    name: "Sequence Editor",
    description: "",
    disabled: true,
    tactics: [],
}];

const segments = [{
    name: "Standard",
    description: "A B2B customer who is in a standard relationship with their supplier is therefore neither prone to churn nor a champion in terms of the turnover they generate.",
}, {
    name: "Champion",
    description: "",
}, {
    name: "At Risk",
    description: "",
}];

export const defaultAiAssistantId = "asst_W2InhyIAtD6Te6g8JTa0MCHO";

export async function fetchAssistants() {
    const myHeaders = new Headers();
    myHeaders.append("OpenAI-Beta", "assistants=v2");
    myHeaders.append("Authorization", "Bearer sk-proj-zb780XlrIiVfCSrhI10WT3BlbkFJcVWUmV5FjFN33uVSiJ7c");
    myHeaders.append("Cookie", "__cf_bm=FVYgCGHCyjQBHQ5hxr97nLjHbZsECWJzZV2e.bUZ3LM-1722952509-1.0.1.1-7cEcteT75pdyTxijxlucNXWpb8vKVqULelQ6DtKxPjkzc4R4vtRRrdv4Wq3wbgxj_pvzB1F39gpqRSFRq8AV9A; _cfuvid=QH30SsOvSjbDBRnRgUxubmQUz.vG8eOGHzQoOIEEf34-1722952509967-0.0.1.1-604800000");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    const response = await fetch("https://api.openai.com/v1/assistants", requestOptions);
    const responseJSON = await response.json();
    return responseJSON.data || [];
}

export const emailTemplateJSON = {
    "counters": {
        "u_row": 17,
        "u_column": 21,
        "u_content_text": 28,
        "u_content_image": 6,
        "u_content_button": 5,
        "u_content_divider": 4,
        "u_content_heading": 3
    },
    "body": {
        "id": "0_vS6UTvNF",
        "rows": [
            {
                "id": "-TOPP-VJ93",
                "cells": [
                    1
                ],
                "columns": [
                    {
                        "id": "ATSuLEw8tk",
                        "contents": [
                            {
                                "id": "b8H9NmRe31",
                                "type": "image",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "src": {
                                        "url": "{{{organization.metadata.logoUrl}}}",
                                        "width": 174,
                                        "height": 47
                                    },
                                    "textAlign": "center",
                                    "altText": "",
                                    "action": {
                                        "name": "web",
                                        "values": {
                                            "href": "",
                                            "target": "_blank"
                                        }
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_image_6",
                                        "htmlClassNames": "u_content_image"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true
                                }
                            },
                            {
                                "id": "IdOSTc0zQd",
                                "type": "heading",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "headingType": "h1",
                                    "fontWeight": 700,
                                    "fontSize": "47px",
                                    "color": "{{organization.metadata.primaryColor}}",
                                    "textAlign": "center",
                                    "lineHeight": "140%",
                                    "linkStyle": {
                                        "inherit": true,
                                        "linkColor": "#0000ee",
                                        "linkHoverColor": "#0000ee",
                                        "linkUnderline": true,
                                        "linkHoverUnderline": true
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_heading_1",
                                        "htmlClassNames": "u_content_heading"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "<span><span><span>{{ headline }}</span></span></span>",
                                    "_override": {
                                        "mobile": {
                                            "fontSize": "30px"
                                        }
                                    }
                                }
                            },
                            {
                                "id": "BvZQ46bQYQ",
                                "type": "image",
                                "values": {
                                    "containerPadding": "10px 10px 20px",
                                    "anchor": "",
                                    "src": {
                                        "url": "{{{organization.metadata.centralImageUrl}}}",
                                        "width": 2838,
                                        "height": 1647
                                    },
                                    "textAlign": "center",
                                    "altText": "",
                                    "action": {
                                        "name": "web",
                                        "values": {
                                            "href": "",
                                            "target": "_blank"
                                        }
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_image_1",
                                        "htmlClassNames": "u_content_image"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "",
                                    "linkStyle": {
                                        "inherit": false,
                                        "linkColor": "",
                                        "linkUnderline": false,
                                        "linkHoverColor": "",
                                        "linkHoverUnderline": false
                                    },
                                    "lineHeight": ""
                                }
                            }
                        ],
                        "values": {
                            "_meta": {
                                "htmlID": "u_column_1",
                                "htmlClassNames": "u_column"
                            },
                            "border": {},
                            "padding": "",
                            "borderRadius": "",
                            "backgroundColor": ""
                        }
                    }
                ],
                "values": {
                    "displayCondition": null,
                    "columns": false,
                    "backgroundColor": "rgba(255,255,255,0)",
                    "columnsBackgroundColor": "rgba(255,255,255,0)",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": "no-repeat",
                        "size": "custom",
                        "position": "top-left",
                        "customPosition": [
                            "0%",
                            "0%"
                        ]
                    },
                    "padding": "10px",
                    "anchor": "",
                    "hideDesktop": false,
                    "_meta": {
                        "htmlID": "u_row_1",
                        "htmlClassNames": "u_row"
                    },
                    "selectable": true,
                    "draggable": true,
                    "duplicatable": true,
                    "deletable": true,
                    "hideable": true
                }
            },
            {
                "id": "GaFLCjHL9F",
                "cells": [
                    1
                ],
                "columns": [
                    {
                        "id": "4dkxEJX09Z",
                        "contents": [
                            {
                                "id": "U8Epdbv2Fy",
                                "type": "text",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "fontSize": "14px",
                                    "textAlign": "left",
                                    "lineHeight": "140%",
                                    "linkStyle": {
                                        "inherit": true,
                                        "linkColor": "#0000ee",
                                        "linkHoverColor": "#0000ee",
                                        "linkUnderline": true,
                                        "linkHoverUnderline": true
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_text_23",
                                        "htmlClassNames": "u_content_text"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "<p style=\"line-height: 140%;\">{{ greeting }}</p>"
                                }
                            },
                            {
                                "id": "yAZwRnyNc5",
                                "type": "text",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "fontSize": "14px",
                                    "textAlign": "left",
                                    "lineHeight": "140%",
                                    "linkStyle": {
                                        "inherit": true,
                                        "linkColor": "#0000ee",
                                        "linkHoverColor": "#0000ee",
                                        "linkUnderline": true,
                                        "linkHoverUnderline": true
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_text_24",
                                        "htmlClassNames": "u_content_text"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "<p style=\"line-height: 140%;\">{{ mainText }}</p>"
                                }
                            },
                            {
                                "id": "-DY_hmlgB_",
                                "type": "heading",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "headingType": "h1",
                                    "fontWeight": 700,
                                    "fontSize": "24px",
                                    "color": "{{organization.metadata.primaryColor}}",
                                    "textAlign": "center",
                                    "lineHeight": "140%",
                                    "linkStyle": {
                                        "inherit": true,
                                        "linkColor": "#0000ee",
                                        "linkHoverColor": "#0000ee",
                                        "linkUnderline": true,
                                        "linkHoverUnderline": true
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_heading_2",
                                        "htmlClassNames": "u_content_heading"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "<span><span><span>{{ subTitle1 }}</span></span></span>",
                                    "_override": {
                                        "mobile": {
                                            "fontSize": "30px"
                                        }
                                    }
                                }
                            }
                        ],
                        "values": {
                            "_meta": {
                                "htmlID": "u_column_17",
                                "htmlClassNames": "u_column"
                            },
                            "border": {},
                            "padding": "0px",
                            "borderRadius": "0px",
                            "backgroundColor": ""
                        }
                    }
                ],
                "values": {
                    "displayCondition": null,
                    "columns": false,
                    "backgroundColor": "",
                    "columnsBackgroundColor": "",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": "no-repeat",
                        "size": "custom",
                        "position": "top-center",
                        "customPosition": [
                            "50%",
                            "0%"
                        ]
                    },
                    "padding": "0px",
                    "anchor": "",
                    "hideDesktop": false,
                    "_meta": {
                        "htmlID": "u_row_14",
                        "htmlClassNames": "u_row"
                    },
                    "selectable": true,
                    "draggable": true,
                    "duplicatable": true,
                    "deletable": true,
                    "hideable": true
                }
            },
            {
                "id": "tkm951TyYP",
                "cells": [
                    1
                ],
                "columns": [
                    {
                        "id": "AWV1sB4CVN",
                        "contents": [
                            {
                                "id": "d84JmjK1V5",
                                "type": "text",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "fontSize": "14px",
                                    "textAlign": "center",
                                    "lineHeight": "140%",
                                    "linkStyle": {
                                        "inherit": true,
                                        "linkColor": "#0000ee",
                                        "linkHoverColor": "#0000ee",
                                        "linkUnderline": true,
                                        "linkHoverUnderline": true
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_text_25",
                                        "htmlClassNames": "u_content_text"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "{{#valuePropositionBulletsPoints}}<p style=\"line-height: 140%;\">{{.}}</p><br />{{/valuePropositionBulletsPoints}}"
                                }
                            },
                            {
                                "id": "t-QEAhg5Ny",
                                "type": "heading",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "headingType": "h1",
                                    "fontWeight": 700,
                                    "fontSize": "24px",
                                    "color": "{{organization.metadata.primaryColor}}",
                                    "textAlign": "center",
                                    "lineHeight": "140%",
                                    "linkStyle": {
                                        "inherit": true,
                                        "linkColor": "#0000ee",
                                        "linkHoverColor": "#0000ee",
                                        "linkUnderline": true,
                                        "linkHoverUnderline": true
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_heading_3",
                                        "htmlClassNames": "u_content_heading"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "<span>{{ subTitle2 }}</span>",
                                    "_override": {
                                        "mobile": {
                                            "fontSize": "30px"
                                        }
                                    }
                                }
                            },
                            {
                                "id": "-XseRHOT8a",
                                "type": "text",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "fontSize": "14px",
                                    "textAlign": "left",
                                    "lineHeight": "140%",
                                    "linkStyle": {
                                        "inherit": true,
                                        "linkColor": "#0000ee",
                                        "linkHoverColor": "#0000ee",
                                        "linkUnderline": true,
                                        "linkHoverUnderline": true
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_text_28",
                                        "htmlClassNames": "u_content_text"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "<div>\n<div>\n<div id=\"Reviewprompt2\" role=\"tabpanel\" data-v-7212e0a4=\"\" aria-labelledby=\"step-Reviewprompt2\">\n<div data-v-7212e0a4=\"\">\n<div>\n<div data-v-7212e0a4=\"\">\n<div data-v-7212e0a4=\"\">{{ ctaText }}</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div> </div>"
                                }
                            },
                            {
                                "id": "Aj8DgKvJMz",
                                "type": "button",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "href": {
                                        "name": "web",
                                        "values": {
                                            "href": "https://del.vse.cz/",
                                            "target": "_blank"
                                        },
                                        "attrs": {
                                            "href": "{{href}}",
                                            "target": "{{target}}"
                                        }
                                    },
                                    "buttonColors": {
                                        "color": "#FFFFFF",
                                        "backgroundColor": "{{#organization.metadata.primaryColor}}{{organization.metadata.primaryColor}}{{/organization.metadata.primaryColor}}{{^organization.metadata.primaryColor}}#ea1674{{/organization.metadata.primaryColor}}",
                                        "hoverColor": "#FFFFFF",
                                        "hoverBackgroundColor": "#3AAEE0"
                                    },
                                    "size": {
                                        "autoWidth": true,
                                        "width": "100%"
                                    },
                                    "fontSize": "14px",
                                    "textAlign": "center",
                                    "lineHeight": "120%",
                                    "padding": "10px 20px",
                                    "border": {},
                                    "borderRadius": "4px",
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_button_5",
                                        "htmlClassNames": "u_content_button"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "<strong>CTA button</strong>",
                                    "linkStyle": {
                                        "inherit": false,
                                        "linkColor": "",
                                        "linkUnderline": false,
                                        "linkHoverColor": "",
                                        "linkHoverUnderline": false
                                    },
                                    "calculatedWidth": 123,
                                    "calculatedHeight": 37
                                },
                                "hasDeprecatedFontControls": true
                            }
                        ],
                        "values": {
                            "_meta": {
                                "htmlID": "u_column_18",
                                "htmlClassNames": "u_column"
                            },
                            "border": {},
                            "padding": "0px",
                            "borderRadius": "0px",
                            "backgroundColor": ""
                        }
                    }
                ],
                "values": {
                    "displayCondition": null,
                    "columns": false,
                    "backgroundColor": "",
                    "columnsBackgroundColor": "",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": "no-repeat",
                        "size": "custom",
                        "position": "top-center",
                        "customPosition": [
                            "50%",
                            "0%"
                        ]
                    },
                    "padding": "0px",
                    "anchor": "",
                    "hideDesktop": false,
                    "_meta": {
                        "htmlID": "u_row_15",
                        "htmlClassNames": "u_row"
                    },
                    "selectable": true,
                    "draggable": true,
                    "duplicatable": true,
                    "deletable": true,
                    "hideable": true
                }
            },
            {
                "id": "RmEvlabbdt",
                "cells": [
                    1
                ],
                "columns": [
                    {
                        "id": "WWRuUeIkZ2",
                        "contents": [
                            {
                                "id": "LC6CxLTHyG",
                                "type": "text",
                                "values": {
                                    "containerPadding": "10px",
                                    "anchor": "",
                                    "fontSize": "14px",
                                    "textAlign": "left",
                                    "lineHeight": "140%",
                                    "linkStyle": {
                                        "inherit": true,
                                        "linkColor": "#0000ee",
                                        "linkHoverColor": "#0000ee",
                                        "linkUnderline": true,
                                        "linkHoverUnderline": true
                                    },
                                    "hideDesktop": false,
                                    "displayCondition": null,
                                    "_meta": {
                                        "htmlID": "u_content_text_15",
                                        "htmlClassNames": "u_content_text"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "hideable": true,
                                    "text": "<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">Tuto zprávu Vám posíláme proto, že jste nám udělili souhlas se zasíláním obchodních a marketingových sdělení. Z odběru se můžete <a rel=\"noopener\" href=\"https://app.omnicrane.com/unsubscribe?email={{ footerEmail }}&unsubscribeLink={{ footerUnsubscribeLink }}\" target=\"_blank\" data-u-link-value=\"eyJuYW1lIjoid2ViIiwiYXR0cnMiOnsiaHJlZiI6Int7aHJlZn19IiwidGFyZ2V0Ijoie3t0YXJnZXR9fSJ9LCJ2YWx1ZXMiOnsiaHJlZiI6Imh0dHBzOi8vYXBwLm9tbmljcmFuZS5jb20vdW5zdWJzY3JpYmU/ZW1haWw9e3sgZW1haWwgfX0mdW5zdWJzY3JpYmVMaW5rPXt7IHVuc3Vic2NyaWJlX2xpbmsgfX0iLCJ0YXJnZXQiOiJfYmxhbmsifX0=\">odhlásit</a>.</span></p>\n<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"> </p>\n<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"font-size: 12px; line-height: 16.8px;\">Informace o zpracování osobních údajů správcem  OmniCrane najdete <a rel=\"noopener\" href=\"https://www.omnicrane.com/en/privacy\" target=\"_blank\" data-u-link-value=\"eyJuYW1lIjoid2ViIiwiYXR0cnMiOnsiaHJlZiI6Int7aHJlZn19IiwidGFyZ2V0Ijoie3t0YXJnZXR9fSJ9LCJ2YWx1ZXMiOnsiaHJlZiI6Imh0dHBzOi8vd3d3Lm9tbmljcmFuZS5jb20vZW4vcHJpdmFjeSIsInRhcmdldCI6Il9ibGFuayJ9fQ==\">zde.</a></span></p>"
                                },
                                "hasDeprecatedFontControls": true
                            }
                        ],
                        "values": {
                            "_meta": {
                                "htmlID": "u_column_14",
                                "htmlClassNames": "u_column"
                            },
                            "border": {},
                            "padding": "",
                            "borderRadius": "",
                            "backgroundColor": ""
                        }
                    }
                ],
                "values": {
                    "displayCondition": null,
                    "columns": false,
                    "backgroundColor": "#f0f0f0",
                    "columnsBackgroundColor": "rgba(255,255,255,0)",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": "no-repeat",
                        "size": "custom",
                        "position": "top-left",
                        "customPosition": [
                            "0%",
                            "0%"
                        ]
                    },
                    "padding": "30px",
                    "anchor": "",
                    "hideDesktop": false,
                    "_meta": {
                        "htmlID": "u_row_11",
                        "htmlClassNames": "u_row"
                    },
                    "selectable": false,
                    "draggable": false,
                    "duplicatable": true,
                    "deletable": false,
                    "hideable": true
                }
            }
        ],
        "headers": [],
        "footers": [],
        "values": {
            "popupPosition": "center",
            "popupWidth": "600px",
            "popupHeight": "auto",
            "borderRadius": "10px",
            "contentAlign": "center",
            "contentVerticalAlign": "center",
            "contentWidth": "600px",
            "fontFamily": {
                "label": "Montserrat",
                "value": "'Montserrat',sans-serif",
                "type": "google",
                "weights": "400,700"
            },
            "textColor": "#000000",
            "popupBackgroundColor": "#FFFFFF",
            "popupBackgroundImage": {
                "url": "",
                "fullWidth": true,
                "repeat": "no-repeat",
                "size": "cover",
                "position": "top-center",
                "customPosition": [
                    "50%",
                    "0%"
                ]
            },
            "popupOverlay_backgroundColor": "rgba(0, 0, 0, 0.1)",
            "popupCloseButton_position": "top-right",
            "popupCloseButton_backgroundColor": "#DDDDDD",
            "popupCloseButton_iconColor": "#000000",
            "popupCloseButton_borderRadius": "0px",
            "popupCloseButton_margin": "0px",
            "popupCloseButton_action": {
                "name": "close_popup",
                "attrs": {
                    "onClick": "document.querySelector('.u-popup-container').style.display = 'none';"
                }
            },
            "backgroundColor": "#ffffff",
            "preheaderText": "",
            "linkStyle": {
                "body": true,
                "linkColor": "#0000ee",
                "linkHoverColor": "#0000ee",
                "linkUnderline": true,
                "linkHoverUnderline": true
            },
            "backgroundImage": {
                "url": "",
                "fullWidth": true,
                "repeat": "no-repeat",
                "size": "custom",
                "position": "top-center",
                "customPosition": [
                    "50%",
                    "0%"
                ]
            },
            "_meta": {
                "htmlID": "u_body",
                "htmlClassNames": "u_body"
            }
        }
    },
    "schemaVersion": 16
};

export function utf8ToBase64(str) {
    return btoa(unescape(encodeURIComponent(str)));
}

export function base64ToUtf8(base64) {
    return decodeURIComponent(escape(atob(base64)));
}

export function generatePrompt({
    useCaseName,
    tacticName,
    organizationName,
    organizationMetadata,
    productExpertContext,
    language = 'czech',
    productName,
    productDescription,
    // TODO: APP-190 - uncomment and solve problem with long RAG ctx
    // productRAGContext,
}) {
    const organizationDescription = JSON.stringify(organizationMetadata);
    const useCaseDescription = useCases.find(i => i.name === useCaseName)?.description;
    const tacticDescription = useCases.find(i => i.name === useCaseName)?.tactics?.find(i => i.name === tacticName)?.description;
    const renderedTacticDescription = Mustache.render(tacticDescription, {
        organization: {
            metadata: organizationMetadata,
        },
        productName,
        productDescription,
    });
    const productExpertContextAddition = `For better results, please consider also following additional context in markdown formatting: "${productExpertContext}"`;

    // TODO: APP-190 - uncomment and solve problem with long RAG ctx
    // const productAddition = productName ? `When writing the text, you may be inspired by the following context (${productRAGContext}) for product "${productName}" with description: ${productDescription}` : '';
    const productAddition = productName ? `When writing the text, you may be inspired by the following product "${productName}" with description: ${productDescription}` : '';

    let prompt = `
        You are an experienced product marketing expert working in an organization "${organizationName}" described by this metadata: ${organizationDescription}

        Your task is to craft the content for an engaging email newsletter aimed at a use case called "${useCaseName}" described as "${useCaseDescription}".

        To achieve this goal, apply the following tactics "${tacticName}": "${renderedTacticDescription}".

        ${productAddition}

        Please write the email text in high-quality ${language} language, targeting the "Standard" customer segment, defined as: "A B2B customer who is in a standard relationship with their supplier, neither prone to churn nor a champion in terms of turnover."
    `;

    if (productExpertContext) {
        prompt = prompt + `\n ${productExpertContextAddition}`;
    }

    return prompt;
}

export async function sendPrompt(prompt, assistantId) {
    // =======
    // GPT API
    // =======

    // create thread
    const GPT_KEY = "sk-proj-zb780XlrIiVfCSrhI10WT3BlbkFJcVWUmV5FjFN33uVSiJ7c";

    const myHeaders = new Headers();
    myHeaders.append("OpenAI-Beta", "assistants=v2");
    myHeaders.append("Authorization", `Bearer ${GPT_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    const createThreadResponse = await fetch("https://api.openai.com/v1/threads", {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
    });
    const createThreadResponseJSON = await createThreadResponse.json();
    const threadId = createThreadResponseJSON.id;

    // run thread
    await fetch(`https://api.openai.com/v1/threads/${threadId}/runs`, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          "assistant_id": assistantId,
          "additional_messages": [
                {
                    "role": "user",
                    "content": prompt
                }
            ]
          }),
        redirect: "follow"
    });

    await pollEndpoint(`https://api.openai.com/v1/threads/${threadId}/runs`, myHeaders, 3000);

    // get messages
    const messagesResponse = await fetch(`https://api.openai.com/v1/threads/${threadId}/messages`, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    })
    const messagesResponseJSON = await messagesResponse.json();
    const value = messagesResponseJSON.data[0].content[0].text.value;
    const jsonValue = JSON.parse(value);
    console.log('jsonValue:', jsonValue);

    return jsonValue;
}

async function pollEndpoint(url, headers = {}, interval = 2000) {
    const checkStatus = async () => {
        try {
            const response = await fetch(url, {
                headers,
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            
            const data = await response.json();
            if (data?.data?.[0]?.status === 'completed') {
                console.log("Run is complete", data);
                return true;
            } else {
                console.log("Run not ready yet");
                return false;
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            return false;
        }
    };

    const poll = async () => {
        while (!(await checkStatus())) {
            await new Promise(resolve => setTimeout(resolve, interval));
        }
    };

    await poll();
}

export function generateRandomHash() {
    const array = new Uint8Array(8); // Array of 16 random bytes
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => ('0' + byte.toString(16)).slice(-2)).join('');
}

export function getProductExpertContextStorageKey(sessionId) {
    return `product-expert_${sessionId}`;
}

export function cleanupProductExpertStorage(){
    const nOfKeys = localStorage.length;
    const aiAssistantKeys = [];

    for (let index = 0; index < nOfKeys; index++) {
        const key = localStorage.key(index);
        if (key.startsWith('product-expert')) {
            aiAssistantKeys.push(key);
        }        
    }

    for (const key of aiAssistantKeys) {
        localStorage.removeItem(key);
    }
}